__turbopack_context__.v({
  "buttonWrapper": "search-layout-module-scss-module__lj5vIq__buttonWrapper",
  "closeButton": "search-layout-module-scss-module__lj5vIq__closeButton",
  "controls": "search-layout-module-scss-module__lj5vIq__controls",
  "filtersButton": "search-layout-module-scss-module__lj5vIq__filtersButton",
  "openControls": "search-layout-module-scss-module__lj5vIq__openControls",
  "results": "search-layout-module-scss-module__lj5vIq__results",
  "wrapper": "search-layout-module-scss-module__lj5vIq__wrapper",
});
